<template>
  <div>
    <div :class="{'modal-backdrop show': PersonalModalShow}" @click.stop="closeModal"></div>
    <div :class="{'show': PersonalModalShow}"
    class="col-md-3 px-0 border-right position-fixed bg-white no-scrollbar personal-sidebar"
    style="overflow-y: scroll; z-index: 1041;" ref="course-sidebar">
      <div class="modal-header flex-column">
        <a href="#" @click.prevent="closeModal" class="d-md-inline-block d-none">
          <span class="material-icons"> keyboard_backspace </span>
        </a>
        <div class="py-4 px-3 sticky-top course-title-bg">
          <div class="d-flex align-items-center">
            <img :src="userPic || 'https://www.gravatar.com/avatar'" class="rounded-circle bg-cover" width="72px" height="72px" alt="">
            <div class="ml-3">
              <h4 class="mb-0">{{ userInfo.full_name }}</h4>
              <p class="mb-0 text-muted">{{ userInfo.email }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-body px-0">
        <div>
          <a href="/dashboard" class="border-0 text-secondary px-xl-5 px-lg-4 px-3
            custom-collapse-icon list-group-item list-group-item-action
            border-right-0 border-bottom-0 d-flex justify-content-between">
            <span>
              <span class="material-icons align-bottom mr-2"> dashboard </span> 學習中心
            </span>
          </a>
        </div>
        <div>
          <a href="#my-course" class="border-0 text-secondary px-xl-5 px-lg-4 px-3
            custom-collapse-icon list-group-item list-group-item-action
            border-right-0 border-bottom-0 d-flex justify-content-between collapsed"
            data-toggle="collapse" role="button">
            <span>
              <span class="material-icons align-bottom mr-2"> library_books </span> 我的課程
            </span>
            <span class="material-icons fa-chevron-up text-primary"> keyboard_arrow_up </span>
            <span class="material-icons fa-chevron-down text-primary"> keyboard_arrow_down </span>
          </a>
          <div class="collapse rounded-0" id="my-course">
            <div class="list-group rounded-0 border-0">
              <a :href="'/course/' + course.course.path_var"
              class="lecture-item px-xl-5 px-lg-4 px-3 border-0
              list-group-item list-group-item-action d-flex align-items-start"
              v-for="course in checkItemActive(courseList)" :key="course.id">
              <span style="padding-left: 36px;">{{ course.course.name }}</span></a>
            </div>
          </div>
        </div>
        <div>
          <a href="#learn-source" class="border-0 text-secondary
            px-xl-5 px-lg-4 px-3 custom-collapse-icon
            list-group-item list-group-item-action
            border-right-0 border-bottom-0 d-flex justify-content-between collapsed"
            data-toggle="collapse" role="button">
            <span>
              <span class="material-icons align-bottom mr-2"> bookmark </span> 學院資源
            </span>
            <span class="material-icons fa-chevron-up text-primary"> keyboard_arrow_up </span>
            <span class="material-icons fa-chevron-down text-primary"> keyboard_arrow_down </span>
          </a>
          <div class="collapse rounded-0" id="learn-source">
            <div class="list-group rounded-0 border-0">
              <a href="/community" class="lecture-item px-xl-5 px-lg-4 px-3
              border-0 list-group-item list-group-item-action d-flex align-items-start">
              <span style="padding-left: 36px;">社團公告</span> </a>
              <a href="/school" class="lecture-item px-xl-5 px-lg-4 px-3
              border-0 list-group-item list-group-item-action d-flex align-items-start">
              <span style="padding-left: 36px;">學院公告</span></a>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer px-0 w-100">
        <div class="list-group w-100">
          <a href="/account" class="px-xl-5 px-lg-4 px-3 text-secondary
          list-group-item list-group-item-action border-0 align-items-center mt-auto">
            <span class="material-icons" style="vertical-align: bottom;"> settings </span> 設定
          </a>
          <a href="#" @click.prevent="gaTrackLink('Logout', 'Logout', 'Logout Complete', '/logout')"
            class="px-xl-5 px-lg-4 px-3 text-secondary
            list-group-item list-group-item-action border-0 align-items-center">
            <span class="material-icons" style="vertical-align: bottom;"> login </span> 登出
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PersonalSidebar',
  props: {
    userData: String,
    userPic: String,
  },
  data() {
    return {
      userInfo: JSON.parse(this.userData),
      PersonalModalShow: false,
      courseList: JSON.parse(window.sessionStorage.getItem('biz_thinking_courses')) || [],
    };
  },
  methods: {
    getCourse() {
      const vm = this;
      axios.get('/api/courses').then((res) => {
        vm.courseList = res.data.data;
        window.sessionStorage.setItem('biz_thinking_courses', JSON.stringify(vm.courseList));
      }).catch((err) => {
        flash(`頁面取得錯誤${err}`, 'danger');
      });
    },
    closeModal() {
      this.PersonalModalShow = false;
      $('body').removeClass('modal-open');
      this.$bus.$emit('closeBar', { param: 'openModal', status: false });
    },
  },
  mounted() {
    const vm = this;
    if (vm.courseList.length == 0) vm.getCourse();
    this.$bus.$on('openPersonalModal', (data) => {
      if (data) {
        vm.PersonalModalShow = data;
        $('body').addClass('modal-open');
      } else {
        vm.PersonalModalShow = data;
        $('body').removeClass('modal-open');
      }
    });
  },
};
</script>

<style lang="scss" scoped>
  $progress-primary: #3D5AFE;
  $progress-light: #E8EAF6;

  .custom-collapse-icon {
    .fa-chevron-up {
      display: inline-block;
    }
    .fa-chevron-down {
      display: none;
    }
  }
  .custom-collapse-icon.collapsed {
    .fa-chevron-up {
      display: none;
    }
    .fa-chevron-down {
      display: inline-block;
    }
  }
  @media(min-width: 768px) {
    .modal-body {
      overflow-y: auto;
      max-height: calc(100vh - 130px - 185px);
    }
  }
</style>
